module.exports = __webpack_public_path__ + "static/media/home-service-slider-8.8a34badb.jpg";